var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconIllustrativeWarningAlt = function IconIllustrativeWarningAlt(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    color: "#FF5800",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8 8.2C50.023 2.301 41.012.06 32 0 22.989.061 13.978 2.303 8.2 8.2 2.302 13.977.06 22.988 0 32c.061 9.011 2.303 18.023 8.2 23.8 5.777 5.898 14.789 8.14 23.8 8.2 9.011-.061 18.022-2.302 23.8-8.2C61.699 50.023 63.94 41.012 64 32c-.061-9.011-2.302-18.023-8.2-23.8",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.478 33.847h-.956c-.826-4.008-1.224-5.699-1.224-6.3a1.702 1.702 0 113.404 0c0 .601-.312 2.154-1.224 6.3zM32 39.14a1.702 1.702 0 110-3.404 1.702 1.702 0 010 3.404zm12.537-.425c-1.264-2.769-4.137-7.875-6.425-11.708-4.722-7.913-5.456-8.284-6.112-8.17-.665-.113-1.39.258-6.113 8.17-2.287 3.834-5.16 8.94-6.425 11.708-.49 1.073-.92 2.013-.407 2.59.189.5.902 1.911 12.945 1.911 12.042 0 12.756-1.41 12.945-1.91.512-.578.083-1.518-.408-2.591z",
    fill: "#fff"
  }));
};

IconIllustrativeWarningAlt.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconIllustrativeWarningAlt;
//# sourceMappingURL=IconIllustrativeWarningAlt.js.map